export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13593.5da90804.jpg";